import {
  CLEANUPOPERATION
} from 'actions/pzCustom/cleanUpOperation';
export const initialState = {
  isFetching: false,
  data: []
};
export const cleanUpOperationList = (state = initialState, action) => {
  switch (action.type) {
    case `${CLEANUPOPERATION}_PENDING`:
      return Object.assign({}, initialState, {
        isFetching: true
      });
    case `${CLEANUPOPERATION}_SUCCESS`:
      return Object.assign({}, state, {
        isFetching: false,
        data: action.payload.data,
        allData: action.payload
      });
    default:
      return state;
  }
};

